module.exports = __webpack_public_path__ + "static/media/traditional_invitation.b770c631.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/traditional_invitation.png
// module id = 163
// module chunks = 0